import FnrFetch3 from "Utilities/FnrFetch/FnrFetch3";
import { fnThrowError } from "Utilities/fnReportError";

const uploadFile = async (postData, onUploadProgress) => {
  const endpoint = `/extendedField/document/upload`;
  const fetchFunction = new FnrFetch3(endpoint, postData, {
    onUploadProgress,
  });

  const response = await fetchFunction.post().catch((err) =>
    fnThrowError({
      message: `Error at ${endpoint}: ${err}`,
    })
  );

  return response;
};

const clearExtendedFieldResponse = async ({ targetUserID, networkFieldID }) => {
  const endpoint = `/user/${targetUserID}/clearExtendedFieldResponse?networkFieldID=${networkFieldID}`;
  const fetchFunction = new FnrFetch3(endpoint);

  const response = await fetchFunction.post().catch((err) =>
    fnThrowError({
      message: `Error at ${endpoint}: ${err}`,
    })
  );

  return response;
};

/**
 * @param {number} userID
 * @param {FormData} formData
 */
const setExtendedField = async (userID, formData) => {
  const endpoint = `/user/${userID}/saveExtendedFieldResponse`;
  const fetchFunction = new FnrFetch3(endpoint, formData);

  const response = await fetchFunction.post().catch((err) => {
    if (err) return err;
    // fnThrowError({
    //   message: `Error at ${endpoint}: ${err}`,
    // });
  });

  return response;
};

export { uploadFile, clearExtendedFieldResponse, setExtendedField };
